import { Box, SxProps, Theme, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

const initialsOf = (label: string): string => {
  const words = label.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

interface UserAvatarProps {
  /** Texto de onde sai a inicial (nome ou e-mail) */
  label: string;
  size?: number;
  /** "brand" = sobre a sidebar colorida; "surface" = sobre fundos de página */
  variant?: "brand" | "surface";
  sx?: SxProps<Theme>;
}

/** Avatar circular com a inicial do usuário */
export default function UserAvatar({ label, size = 38, variant = "surface", sx }: UserAvatarProps) {
  const theme = useTheme();
  const colors =
    variant === "brand"
      ? { backgroundColor: theme.palette.brand.switcherActiveBg, color: theme.palette.brand.switcherActiveText }
      : { backgroundColor: theme.palette.brand.cream, color: theme.palette.primary.main };

  return (
    <Box
      sx={[
        {
          width: size,
          height: size,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: size * 0.34,
          flexShrink: 0,
          ...colors,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ] as SxProps<Theme>}
    >
      {initialsOf(label)}
    </Box>
  );
}
